import script from "./Splitscreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./Splitscreen.vue?vue&type=script&setup=true&lang=ts"

import "./Splitscreen.vue?vue&type=style&index=0&id=2710e4e6&lang=scss"
import "./Splitscreen.vue?vue&type=style&index=1&id=2710e4e6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2710e4e6"]])

export default __exports__